<template>
  <div class="editor-main-inside">
    <TableHeader />
    <!-- @scroll="handleScroll" -->
    <div id="editorBox" ref="editorBox" class="content-area-wrap" @contextmenu.prevent="handleOpenMenu($event)">
      <el-row class="content-area" v-for="(item, index) in (getList)" :key="item.id"
        :class="{ 'last-content': getList.length === index + 1, 'active-section': parseInt(item.id) === parseInt(currentId) }"
        :infoId="item.id" :uid="item.transUserId" :id="`content-${item.id}`">
        <el-col class="order" :span="1">
          <span class="inside">
            {{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }} </span>
        </el-col>
        <el-col :span="11" type="source" v-if="componentsState" class="source editor"
          :class="`font-${getEditorFontSizeInfo} `">
          <div class="df" :id="'source-df' + item.id"></div>
          <ContenteditableHTML :flag="flag" :isOpenQa="isOpenQa" :isPreMts='isPreMt' type='source' :itemInfos='item'
            :ref='`source-${item.id}`' :id='`source-${item.id}`' :contenteditable="true" :fragmentIndex="(index + 1)"
            :info="getInfo(item, 'source')" @click.native="(e) => handleEditor(e, item, 'source')"
            @mouseup.native="(e) => handleMouseup(e, item, 'source')" @focus.native="toggleFlag(item, 'source')"
            @blur.native="(e) => handleBlur(e, item, 'source', index)"
            @keyup.native="(e) => handleKeyupSource(e, item, index, 'source')"
            @keydown.native="(e) => handleKeyup(e, item, 'source', index)"
            @mousedown.native="(e) => handleMousedown(e, 'source')" @paste.native="(e) => handlePaste(e, item)" />
        </el-col>
        <el-col :span="12" type="target" v-if="componentsState" class="target editor"
          :class="`font-${getEditorFontSizeInfo} ${getisContent(item.id)} `">
          <div class="df" ref="df" :id="'target-df' + item.id"></div>
          <ContenteditableTargetHTML :flag="flag" :isPreMts='isPreMt' type='target' :itemInfos='item'
            :ref='`target-${item.id}`' :id='`target-${item.id}`' :contenteditable="true" :fragmentIndex="(index + 1)"
            :info="getInfo(item, 'target')" @click.native="(e) => handleEditor(e, item, 'target')"
            @mouseup.native="(e) => handleMouseup(e, item, 'target')"
            @mousedown.native="(e) => handleMousedown(e, 'target')"
            @blur.native="(e) => handleBlur(e, item, 'target', index)" @focus.native="toggleFlag(item, 'target')"
            @keyup.native="(e) => handleKeyupSource(e, item, index, 'target')"
            @keydown.native="(e) => handleKeyup(e, item, 'target', index, 'enter')"
            @paste.native="(e) => handlePaste(e, item)" />
        </el-col>
      </el-row>
    </div>
    <!--鼠标右键-->
    <MouseRight :mouseInfo="mouseInfo" @handleCloseMenu="handleCloseMenu" @handleRemarks='handleRemarks' />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import TableHeader from "./modules/tableHeader";
import ContenteditableHTML from "./modules/contenteditableHTML";
import { eventUtil } from '@/components/editor/modules/eventUtil';
import ContenteditableTargetHTML from "./modules/contenteditableTargetHTML";
import MouseRight from "./modules/mouseRight";
import {
  setCursorEnd, domArray, domArray2, trimSpace, saveSelection, restoreSelection,
} from "@/services/common";
import moment from "moment"

export default {
  name: "EditorMain",
  components: { TableHeader, ContenteditableHTML, ContenteditableTargetHTML, MouseRight },

  data() {
    return {
      haveAT: haveAT,
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      type: 'source',
      rang: null,
      typeInfo: null,
      currentId: null,
      currentIdType: null,
      targetStr: '',
      updataType: 'blur',
      clickInfo: {},
      mouseInfo: {},
      remarkInfo: {},
      examinationQA: false,
      visibleRemarks: false,
      componentsState: true,
      oldtimeStamp: 0,
      flag: false,
      clientY: "",
      clientX: "",
      contentEditableValue: 'true', //plaintext-only
      selectOldData: "",//存储光标选择的文本
      flagId: "",
      sourceKeyword: '',//原文光标选中文字
      targetKeyword: '',//译文光标选中文字
      getTaskDetailNum: 0, //调取任务详情接口次数
      urlInfo: (JSON.parse(this.$Base64.decode(this.$route.query.key))) || {},
      isupdateStatus: 0,
      page: 1,
      totalPage: null,
      eidtorList: [],
      mousedownType: '',
    };
  },

  watch: {
    getTaskContentListParams: {
      handler(value) {
        if (value.isfilter) {
          this.page = 1;
        }
      },
      deep: true
    },
    editorMode(value, value2) {
      if (value !== value2) {
        this.$forceUpdate()
      }
    },
  },

  computed: {
    ...mapGetters('editor', [
      'getPartIndex',             // 获取预览页码
      'getProjectInfo',           // 获取项目信息
      'getUserInfo',              // 获取当前用户的信息
      'getUrlInfo',               // 路由参数
      'getisSourceedit',          // 编辑原文状态
      'getEditorFontSizeInfo',    // 获取当前字体大小
      'getFileInfo',              // 文件信息
      'getFileTaskInfo',          // 文件任务信息
      'getTaskContentList',       // 获取编辑器文件list ( 文件内容列表 )
      'getSourceeditStatus',      // 获取句子原文的编辑状态
      'getTargeteditStatus',      // 获取句子译文的编辑状态
      'getTaskContentListParams',
    ]),
    /**
     * @desc 是否开启机翻 
     * @return {boolean}
     */
    isPreMt() {
      const { isPreMt } = this.getProjectInfo
      // 0关闭 1开启 
      return isPreMt ? true : false
    },
    /**
     * @desc 是否开启QA
     * @return {boolean}
     */
    isOpenQa() {
      const { isOpenQa } = this.getProjectInfo
      // 0关闭 1开启
      return isOpenQa ? true : false
    },
    //获取片段QA信息
    getFragmentQA() {
      return function (row) {
        let state = false;
        if (!!this.getQAList && !!(this.getQAList.length)) {
          this.getQAList.every((item) => {
            if ((parseInt(item.transFileSentId) === parseInt(row.id))) {
              state = true;
              return false
            } else {
              state = false;
              return true
            }
          });
        }
        return state
      }
    },
    //不使用辅助函数的获取数据-获取文件解析的文本
    getList() {
      if (this.getTaskContentList && this.getTaskContentList.transSentRespVoList) {
        return this.getTaskContentList.transSentRespVoList
      } else {
        return []
      }
    },
    // 编辑器右键功能
    getEditorRightShownInfo() {
      const self = this;
      let editorShownInfo = self.$store.getters['editor/getEditorRightShownInfo'];
      self.form = {
        source: editorShownInfo.sourceKeyword,
        target: editorShownInfo.targetKeyword,
      };
      return editorShownInfo;
    },
    getcountTargetIsnullIdList() {
      return this.$store.getters["editor/getcountTargetIsnullIdList"]
    }
  },
  created() {
    this.checkBrowser();
  },
  mounted() {
    this.$nextTick(() => {
      // 页面注册滚动事件   去除滚动事件
      document.addEventListener('scroll', this.handleScroll);
      // 点击确认句子
      document.addEventListener('mousedown', this.handleClickUpdataState);
      document.body.addEventListener('click', this.handleCloseMenu)
      document.addEventListener("mouseup", this.setTerm);
    })
    this.totalPage = this.getTaskContentList.totalPage
  },

  destroyed() {
    // 页面注册滚动事件
    document.removeEventListener('scroll', this.handleScroll);
    // 点击确认句子
    document.removeEventListener('mousedown', this.handleClickUpdataState);
    document.body.removeEventListener('click', this.handleCloseMenu)
    document.removeEventListener("mouseup", this.setTerm);
  },

  methods: {

    // 获取没有内容的句子
    getisContent(id) {
      let flag = this.getcountTargetIsnullIdList.includes(id);
      if (flag) {
        return "redborder"
      } else {
        return "noborder"
      }
    },
    setPreviewInfo(index = 1) {
      this.index = 1;
      let params = Object();
      let fileId = 0;
      let taskId = 0;
      const { type } = this.urlInfo
      if (type === 'project') {
        fileId = this.getFileInfo.id || this.urlInfo.fileId;
      } else if (type === 'task' || type === 'school') {
        fileId = this.getFileTaskInfo.fileId || this.urlInfo.fileId;
        taskId = this.getFileTaskInfo.id || this.urlInfo.taskId;
      }
      // Reflect.set(params, 'partIndex', 1);
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'taskId', taskId);
      Reflect.set(params, 'partIndex', index);
      this.$store.dispatch('editor/setAppointPreview', params)
    },
    handleMousedown(e, type) {
      this.clientY = e.clientY;
      this.clientX = e.clientX;
      this.mousedownType = type
    },
    toggleFlag(item, type) {
      if (this.lockState(item)) {
        this.flag = item.id + type
      }
    },
    handleClickUpdataState(e) {
      if (e.target.getAttribute('typeInfo')) {
        this.typeInfo = e.target.getAttribute('typeInfo')
      } else {
        this.clickInfo = {
          event: e,
          rang: saveSelection()
        };
      }
    },

    //点击事件：获取当前的id-获取记忆库/术语库-获取批注
    async handleEditor(e, item, sentenceType, keyboard) {
      if (!this.getUrlInfo) {
        return
      }
      const { projectId, fileId, taskId, type, taskType } = this.getUrlInfo
      // 点击句子后 将右侧tab 切换到 翻译建议 
      this.$store.dispatch('editor/setEditorRightActiveName', 'first')
      //如果是作业/测试相关--原文不可以修改
      //聚焦显示单句修改记录
      let params = {};
      if (item) {
        Reflect.set(params, 'transProjectId', projectId);
        Reflect.set(params, 'transFileId', fileId);
        Reflect.set(params, 'taskId', taskId);
        Reflect.set(params, 'sentId', item.id);
        Reflect.set(params, 'partIndex', 1);
        this.$store.dispatch('editor/setModifyRecordInfo', params)
      }
      this.typeInfo = null;
      if (!(type === 'school' && sentenceType === 'source')) {
        let dom = document.getElementById(`${sentenceType}-${item.id}`);
        if (dom) {
          let Ele = dom.getElementsByClassName('hightLight');
          let Ele2 = dom.getElementsByClassName('term');
          //处理术语高亮
          if (Ele2.length) {
            Array.prototype.forEach.call(Ele2, function (item) {
              item.innerHTML = item.innerText;
              item.parentNode.innerText = item.parentNode.innerText;
            });
          }
          //处理检索高亮
          if (Ele.length) {
            this.$message.closeAll();
            this.$message({
              message: '当前句子包含检索高亮词,请刷新页面或者清除高亮再进行编辑',
              type: 'warning'
            });
            this.$store.dispatch("editor/setSourceeditEditorStatus", false);
            this.$store.dispatch("editor/setEleStatus", false)
            return false
          } else {
            this.$store.dispatch("editor/setEleStatus", true)
          }
        }
        //记录光标的位置
        if (keyboard !== 'enter') {
          this.range = saveSelection();
        } else {
          this.range = null
        }
        let currentSentenceInfo = this.$store.getters['editor/getCurrentSentenceIdInfo'];
        let fileId = null;
        let targetLang = 'en';
        let sourceLang = 'zh';
        if (type === 'project') {
          fileId = this.getFileInfo.id;
          sourceLang = this.getFileInfo.sourceLang;
          targetLang = this.getFileInfo.targetLang;
        } else if (type === 'task' || type === 'school') {
          fileId = this.getFileTaskInfo.fileId;
          sourceLang = this.getFileTaskInfo.sourceLang;
          targetLang = this.getFileTaskInfo.targetLang;
        }
        this.currentIdType = `${sentenceType}-${item.id}`;
        if (currentSentenceInfo.currentIdType !== `${sentenceType}-${item.id}`) {
          // 如果这一次点击的句子和上一次点击的句子不是同一句 就将机翻、记忆库、术语库、QA结果置空
          this.currentItem = item;
          this.currentId = `${item.id}`;
          this.currentIdType = `${sentenceType}-${item.id}`;
          let params = {};
          let params2 = {};
          Reflect.set(params, 'currentId', `${item.id}`);
          Reflect.set(params, 'currentIdType', `${sentenceType}-${item.id}`);
          Reflect.set(params2, 'item', item);
          Reflect.set(params2, 'type', sentenceType);
          // this.$store.dispatch('editor/setCursorId', params);
          this.$store.dispatch('editor/setTempSentenceId', params2);
          this.$nextTick(async () => {
            this.oldtimeStamp = (moment().valueOf() / 1000);//获取当前时间秒数
            if (this.range) {
              //将光标的位置设置回来
              restoreSelection(this.range);
              this.range = null;
            } else {
              //焦点定位到最后
              setCursorEnd(dom);
            }
            //如果是作业-测试相关隐匿请求获取术语库和记忆库的操作
            // if (urlInfo.type !== 'school') {
            // 机翻
            if (this.isPreMt && this.haveAT) {
              try {
                // 机翻参数
                let mtParams = {
                  fileId,
                  sid: item.id,
                  taskType: parseInt(taskType)
                }
                const { result, success } = await this.$store.dispatch('editor/setSentenceMt', mtParams)
                success && result && this.$store.dispatch('editor/setSentenceMt2', [result]);
              } catch (error) {
                this.$message.closeAll();
                this.$message.error('机器翻译-错误提示')
              }
            }
            // 记忆库 术语库
            try {
              // 记忆库参数
              let memoryParams = {
                fileId,
                sourcePar: item.sourceSent,
                sourceIndex: item.sourceWordNum,
                taskType: parseInt(taskType)
              };
              // 术语库参数
              let termParams = {
                fileId,
                sourceSent: item.sourceSent,
                sourceLang,
                targetLang,
                taskType: parseInt(taskType),
                // transModel: 1
              };
              const ajaxBankeArr = [
                this.$store.dispatch('editor/setSentMemoryInfo', memoryParams),
                this.$store.dispatch('editor/setSentTermInfo', termParams)
              ]
              const res = await Promise.all(ajaxBankeArr)
              if (!res.length) {
                return
              }
              const resMemory = res[0].result
              const resTerm = res[1].result
              if (resMemory) {
                if (type === 'school') {
                  const arrResult = resMemory.filter(item => item.source !== 3)
                  this.$store.dispatch('editor/setSentMemoryInfo2', arrResult);
                } else {
                  this.$store.dispatch('editor/setSentMemoryInfo2', resMemory);
                }
              }
              resTerm && this.$store.dispatch('editor/setSentTermInfo2', resTerm);
            } catch (error) {
              this.$message.closeAll();
              this.$message.error('记忆库或者术语库-错误提示')
            }

          });
        }
      }
    },

    //译文失去焦点/原文失焦事件
    handleBlur(event, row, type, index) {
      const self = this;
      this.isupdateStatus = 1;
      const setSentCountInfo = {}
      if (event.target.nodeName === 'DIV' && event.target.getAttribute('info')) {
        let sentCOuntInfo = event.target.getAttribute('info')
        if (sentCOuntInfo) {
          setSentCountInfo.key = sentCOuntInfo.split('*')[0].slice(sentCOuntInfo.split('*')[0].indexOf('{') + 1, sentCOuntInfo.split('*')[0].indexOf('}'))
          setSentCountInfo.type = type
          this.$store.dispatch('editor/setSentCountInfo', setSentCountInfo)
        }
      }
      // 句子失去焦点时，将操作区域 “ 编辑原文 ”状态重置为false
      // this.flag = false;
      // this.currentId = null;
      // this.currentIdType = null;
      // this.range = null;
      // let params = {
      //   currentId: null,
      //   currentIdType: null
      // }
      // this.$store.dispatch('editor/setCursorId', params)
      // //设置当前编辑的Id
      const { type: entranceType, projectId, } = this.getUrlInfo
      let fileId = 0;
      let taskId = null;
      let taskType = null;
      if (entranceType === 'project') {
        fileId = this.getFileInfo.id;
      } else if (entranceType === 'task' || entranceType === 'school') {
        fileId = this.getFileTaskInfo.fileId
        taskId = this.getFileTaskInfo.id
        taskType = this.getFileTaskInfo.taskType
      }
      let childrenNodeAll = (event.target.childNodes);
      let innerText = trimSpace(event.target.innerText);
      let info = [];
      let Array2 = [];
      let params = {};
      let timeStamp = (moment().valueOf() / 1000);
      let time = timeStamp - this.oldtimeStamp;
      if (innerText) {
        info = domArray(childrenNodeAll, row, Array2);
      } else {
        let temp = {};
        Reflect.set(temp, 'atomKey', (row.templateKey));
        Reflect.set(temp, 'sort', `${parseInt((row.id).toString().substr(0, 5))}`);
        Reflect.set(temp, 'data', '');
        Reflect.set(temp, 'style', null);
        Reflect.set(temp, 'id', (row.id));
        Reflect.set(temp, 'dataType', 'text');
        Reflect.set(temp, 'tagType', 'text');
        info.push(temp);
        self.$store.dispatch('editor/setUpdataFragmentType', 4);
      }
      Reflect.set(params, 'costTime', Math.floor(time));
      Reflect.set(params, 'taskId', taskId);
      Reflect.set(params, 'taskType', taskType);
      Reflect.set(params, 'isSaveVersion', 0);
      Reflect.set(params, 'sentId', (row.id));
      Reflect.set(params, 'content', innerText);
      Reflect.set(params, 'status', (row.status));
      Reflect.set(params, 'fileId', fileId);
      //修改原文
      if (type === 'source') {
        let sourceTemp = {};
        Reflect.set(sourceTemp, 'sort', 0);
        Reflect.set(sourceTemp, 'text', null);
        Reflect.set(sourceTemp, 'type', null);
        Reflect.set(sourceTemp, 'atoms', info);
        Reflect.set(params, 'sourceTagFragmentVo', sourceTemp);
        Reflect.set(params, 'targetTagFragmentVo', null);
      }
      //修改译文
      if (type === 'target') {
        let targetTemp = {};
        Reflect.set(targetTemp, 'sort', 0);
        Reflect.set(targetTemp, 'text', null);
        Reflect.set(targetTemp, 'type', null);
        Reflect.set(targetTemp, 'atoms', info);
        Reflect.set(params, 'sourceTagFragmentVo', null);
        Reflect.set(params, 'targetTagFragmentVo', targetTemp);
        if ((self.updataType) === 'blur') {
          if (!!(self.typeInfo) && !!innerText) {
            Reflect.set(params, 'isCommitVersion', 1);
          } else {
            Reflect.set(params, 'isCommitVersion', 0);
          }
        } else if ((self.updataType) === 'enter') {
          if (innerText) {
            Reflect.set(params, 'isCommitVersion', 1);
            Reflect.set(params, 'isSaveVersion', 1);
          } else {
            Reflect.set(params, 'isCommitVersion', 0);
          }
        } else if ((self.updataType) === 'enterPre') {
          if (innerText) {
            Reflect.set(params, 'isCommitVersion', 1);
          } else {
            Reflect.set(params, 'isCommitVersion', 0);
          }
        }
      }
      if (type === 'source') {
        let changeFlag = self.checkSourceChange(row.tagSourceSent, params.sourceTagFragmentVo);
        if (changeFlag === 0) {
          return;
          this.isupdateStatus = 0;
        }
      } else if (type === 'target') {
        // let data =.parse(row.tagTargetSent).fragments[0].atoms[0].data
        // let fileId = this.getUrlInfo.fileId
        if (!self.checkTargetChange(row.tagTargetSent, params.targetTagFragmentVo)) {
          this.isupdateStatus = 0;
          return;
        }
      }
      this.eidtorList = this.$store.getters['editor/getEditordataList']
      // 即将插入修改的句子 原本的高亮术语词
      const highlightTerms = {}
      if (row.sourceTermSent && row.sourceTermSent.length) {
        highlightTerms.sourceTermSent = row.sourceTermSent
      }
      if (row.targetTermSent && row.targetTermSent.length) {
        highlightTerms.targetTermSent = row.targetTermSent
      }
      let currentEle = event.target.getAttribute('id');
      if (currentEle) {
        // let currentEleInfo = currentEle.split('-');
        if (this.updataType === 'enter') {
          let contentList = (self.getList);
          let nextItem = contentList[index + 1];
          //修改状态完 清除跳转高亮
          const translatedDom = event.target.parentNode;
          translatedDom.style.border = "none";
          translatedDom.style.borderRight = '1px #E5E5E5 solid';
          // let nextEle = document.getElementById(`${type}-${nextItem.id}`);
          nextItem && self.handleEditor(event, nextItem, type, 'enter');
        } else if ((self.updataType) === 'enterPre') {
          let contentList = (self.getList);
          let preItem = contentList[index - 1];
          preItem && self.handleEditor(event, preItem, type, 'enter');
        }
      }
      this.$nextTick(() => {
        Reflect.set(params, "companyCode", localStorage.myCompanyCode);
        Reflect.set(params, "type", type);
        this.$store.dispatch('editor/setEditordataList', { params, operation: 'set' })
        this.updataType = 'blur';
        this.$store.dispatch('editor/setUpdataFragmentType', 1);
      })
    },
    //检查原译文是否变更
    checkTargetChange(orgTagSent, updateFragments) {
      if (((this.updataType) === 'enter') || ((this.updataType) === 'enterPre')) {
        return true
      } else {
        try {
          if (!orgTagSent) {
            return true;
          }
          let targetTag = JSON.parse(orgTagSent);
          let orgFragments = targetTag.fragments;
          if (orgFragments.length !== 1) {
            return true;
          }
          let orgAtoms = orgFragments[0].atoms;
          let updateAtoms = updateFragments.atoms;
          if (updateAtoms.length !== orgAtoms.length) {
            return true;
          }
          for (let i = 0; i < updateAtoms.length; i++) {
            if (orgAtoms.length < i) {
              return true;
            }
            if (updateAtoms[i].data !== orgAtoms[i].data) {
              return true;
            }
          }
          return false;
        } catch (e) {
          return true;
        }
      }
    },
    checkSourceChange(orgTagSent, updateFragments) {
      try {
        if (!orgTagSent) {
          return 1;
        }
        let targetTag = JSON.parse(orgTagSent);
        let orgFragments = targetTag.fragments;
        if (orgFragments.length !== 1) {
          return 1;
        }
        let orgAtoms = orgFragments[0].atoms;
        let updateAtoms = updateFragments.atoms;
        let orgTagNum = 0;
        let updateTagNum = 0;
        updateAtoms.forEach(item => {
          if (item.dataType === 'tag') {
            updateTagNum += 1;
          }
        });
        orgAtoms.forEach(item => {
          if (item.dataType === 'tag') {
            orgTagNum += 1;
          }
        })
        //tag数量不匹配，原文不允许删除tag
        if (orgTagNum !== updateTagNum) {
          return -1;

        }
        if ((this.updataType) === 'enter' || (this.updataType) === 'enterPre') {
          return 1;
        }
        if (updateAtoms.length !== orgAtoms.length) {
          return 1;
        }
        for (let i = 0; i < updateAtoms.length; i++) {
          if (orgAtoms.length < i) {
            return 1;
          }
          if (updateAtoms[i].data !== orgAtoms[i].data) {
            return 1;
          }
        }
        return 0;
      } catch (e) {
        return 1;
      }
    },
    //译文/原文-键盘回车事件
    handleKeyup(e, row, type, index) {
      if (e.keyCode === 13) {
        eventUtil.preventDefault(e);
        if (this.getList.length > (index + 1)) {
          //失焦当前内容-选中下一个
          this.updataType = 'enter';
          this.$nextTick(() => {
            document.getElementById(`${type}-${row.id}`).blur();
            let wrapper = document.querySelector(`#content-${row.id}`);
            wrapper.scrollIntoView();
          })
        } else {
          //键盘事件事件
          this.$message.closeAll();
          this.$message({
            message: '已经是最后一条信息',
            type: 'warning'
          });
          this.updataType = 'enter';
          document.getElementById(`${type}-${row.id}`).blur();
        }
      }
    },

    // 滚动事件-触底加载分页数据  改成分页 没有触底 禁用了
    handleScroll: _.debounce(
      function (e) {
        let self = this;
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = e.target.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = e.target.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = e.target.scrollHeight;
        //页码
        //滚动条到底部的条件
        if (parseInt((scrollTop + windowHeight + 10)) >= scrollHeight) {
          //写后台加载数据的函数
          // console.log("触底加载更多的数据:距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
          let domHeight = document.getElementsByClassName('hightLight');
          if (domHeight.length != 0) {
            return false;
          }
          // 如果列表有的条数小于总条数，则继续请求往后加载
          const { type } = this.getUrlInfo
          if (this.getTaskContentList.transSentRespVoList.length < this.getTaskContentList.totalRows) {
            let param = this.$store.getters["editor/getTaskContentListParams"];
            if (param.startSort === this.getTaskContentList.totalPage) {
              this.$message.closeAll();
              this.$message.warning("当前已在最后一页");
              return
            }
            param.startSort++;
            param.urltype = type
            self.$store.dispatch('editor/getFileContent', param);
          }
        }
      }, 1000, {
      'leading': true
    }
    ),
    /**
     * @desc 每一条句子的原文 contenteditable 的状态 
     * @return {boolean}
     */

    // /**
    //  * @desc 每一条句子的译文 contenteditable 的状态 
    //  * @return {boolean|string}
    //  */
    //粘贴事件
    handlePaste(e, item) {
      // // 阻止默认粘贴
      e.preventDefault();
      var text;
      var clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
          if (window.getSelection) {
            var newNode = document.createElement("span");
            newNode.innerHTML = text;
            window.getSelection().getRangeAt(0).insertNode(newNode);
          } else {
            document.selection.createRange().pasteHTML(text);
          }
        }
      } else {
        text = clp.getData('text/plain') || "";
        if (text !== "") {
          document.execCommand('insertText', false, text);
        }
      }
    },

    //定义右键
    handleOpenMenu(e) {
      this.selectOldData = window.getSelection().toString()
      if (!!(this.currentIdType) && !!(this.currentId)) {
        let params = {
          top: `${e.clientY + 10}px`,
          left: `${e.clientX + 10}px`,
        };
        this.mouseInfo = {
          visible: true,
          currentItem: this.currentItem,
          id: this.currentIdType.split('-')[1],
          type: this.currentIdType.split('-')[0],
          selectText: this.selectOldData
        };
        this.$store.dispatch('editor/setRightMouseInfo', params)
      }
    },

    //鼠标右键关闭事件
    handleCloseMenu() {
      this.mouseInfo = {
        id: null,
        type: null,
        visible: false,
        selectText: null
      };
      this.targetKeyword = ''
      this.sourceKeyword = ''
    },

    //获取批注信息
    handleGetRemarks(item, remarkStatus) {
      const { type } = this.getUrlInfo
      let fileId = null;
      if (type === 'project') {
        fileId = this.getFileInfo.id
      } else if (type === 'task' || type === 'school') {
        fileId = this.getFileTaskInfo.fileId;
      }
      //点击获取焦点回去批注信息
      if (this.flagId !== item.id) {
        let sentIdList = Array.of((`${item.id}`));
        this.flagId = item.id
        let remarksParams = {
          transFileId: fileId
        };
        Reflect.set(remarksParams, 'sentIdList', sentIdList);
        this.$store.dispatch('editor/getCurrentRemarksInfo', remarksParams);
        if (remarkStatus === 1) {
          this.$store.dispatch('editor/setEditorRightActiveName', 'second')
        } else {
          this.$store.dispatch('editor/setEditorRightActiveName', 'first')
        }
      }
    },

    //批注的弹层
    handleRemarks(item) {
      if (item && !!(item.id)) {
        this.remarkInfo = {
          sentId: (item.id),
          sourceSent: item.sourceSent,
          commentSent: item.sourceSent,
          commentIndex: item.sourceWordNum
        };
        this.visibleRemarks = true;
        //添加批注切换Tab
        this.$store.dispatch('editor/setEditorRightActiveName', 'second');
      }
    },

    //批注的弹层关闭
    handleCancel() {
      this.visibleRemarks = false;
      this.examinationQA = false
    },

    //鼠标抬起
    handleMouseup(e, item, type, params) {
      let oerationSignParams = {}
      if (e.clientX !== this.clientX || e.clientY !== this.clientY) {
        // Reflect.set(oerationSignParams, 'column', this.getEditorRightShownInfo.column);
        // if (type === 'source') {
        //   this.targetKeyword = ''
        //   this.sourceKeyword = window.getSelection().toString()
        //   Reflect.set(oerationSignParams, 'sourceKeyword', this.sourceKeyword);
        //   Reflect.set(oerationSignParams, 'targetKeyword', this.targetKeyword);
        //   this.$store.dispatch('editor/setOerationSignInfo', oerationSignParams);
        // } else {
        //   this.targetKeyword = window.getSelection().toString()
        //   Reflect.set(oerationSignParams, 'sourceKeyword', this.sourceKeyword || this.selectOldData);
        //   Reflect.set(oerationSignParams, 'targetKeyword', this.targetKeyword);
        //   this.$store.dispatch('editor/setOerationSignInfo', oerationSignParams);
        // }
      } else {
        Reflect.set(oerationSignParams, 'column', 'third');
        Reflect.set(oerationSignParams, 'keyword', null);
        this.$store.dispatch('editor/setOerationSignInfo', oerationSignParams);
      }

      if (this.lockState(item)) {
        if (e.target.getAttribute('termid')) {
          this.$message.warning('当前元素为术语内容,不允许对该类型内容进行操作')
          return false
        }
        this.handleGetRemarks(item);
        //   if (item && !!(item.id)) {
        //     console.log(item.id)
        //   this.remarkInfo = {
        //     sentId: (item.id),
        //     sourceSent: (item.sourceSent),
        //     commentSent: (item.sourceSent),
        //     commentIndex: (item.sourceWordNum)
        //   };
        //   // this.visibleRemarks = true;
        //   //添加批注切换Tab
        //   // this.$store.dispatch('editor/setEditorRightActiveName', 'second');
        // }
        let Array1 = Array();
        let Array2 = Array();
        let stringPre = '';
        let stringSuf = '';
        let state = false;
        let enevt = params || (e.target);
        let selection = window.getSelection();
        if ((selection.type) !== 'None') {
          const ele = selection.getRangeAt(0);
          if (!!ele && !!(ele.commonAncestorContainer) && !!(ele.commonAncestorContainer.parentNode) && !!(ele.commonAncestorContainer.parentNode.getAttribute('class'))) {
            let info = (ele.commonAncestorContainer.parentNode.getAttribute('class'));
            let info2 = (enevt.getAttribute('info'));
            //判断原数据字段必须存在
            if (item.tagSourceSent) {
              let currentInfo = (JSON.parse(item.tagSourceSent));
              if (!!(currentInfo.fragments) && (currentInfo.fragments[0]) && (Reflect.has((currentInfo.fragments[0]), 'atoms'))) {
                let params = Array();
                //拆分句对的前半句
                let paramsPre = Object();
                //拆分句子的后半句
                let paramsSuf = Object();
                if (info) {
                  let infoArr = info.split(' ');
                  let infoArr2 = info2 && (info2.split('*'));
                  this.$nextTick(() => {
                    let childrenNodeAll = (e.currentTarget.childNodes);
                    let TextNodes2 = domArray2(childrenNodeAll, Array());
                    let findId = 0;
                    if (!!infoArr && !!(infoArr[6])) {
                      findId = infoArr[6]
                    } else if (infoArr2 && (infoArr2[6])) {
                      findId = infoArr2[6]
                    }
                    if (findId === 0) {
                      let targetNode = null;
                      if (ele.commonAncestorContainer === e.target) {
                        let sIndex = 0;
                        let childNodes = e.target.childNodes;
                        if (e.target.nodeName === 'DIV') {
                          targetNode = childNodes[ele.endOffset === childNodes.length ? ele.endOffset - 1 : ele.endOffset]
                        } else {
                          for (let idx = 0; idx < childNodes.length; idx++) {
                            let node = childNodes[idx];
                            let len = 0;
                            if (node.nodeType === 3) {
                              len = node.nodeValue.length;
                            } else {
                              len = node.innerText.length;
                            }
                            if (ele.endOffset <= idx + sIndex + len) {
                              targetNode = node;
                              break
                            }
                            sIndex += len;
                          }
                        }
                      } else {
                        targetNode = ele.commonAncestorContainer.parentNode;
                      }
                      if (targetNode && targetNode.getAttribute("info")) {
                        infoArr2 = targetNode.getAttribute("info").split("*");
                        if (infoArr2 && (infoArr2[6])) {
                          findId = infoArr2[6];
                        }
                      }
                    }
                    TextNodes2.forEach((item, index) => {
                      if (ele.commonAncestorContainer.nodeValue) {
                        let dataHTML = item.data === undefined ? (item.data) : (item.data).toString().replace(/<[^>]+>/g, "");
                        Reflect.set(item, 'data', dataHTML);
                        // if ((findId === item.fid)) {
                        if (((ele.commonAncestorContainer.nodeValue) === (item.data))) {
                          let start = (item.data).substr(0, (ele.endOffset));
                          let end = (item.data).substr((ele.endOffset));
                          state = true;
                          if (start) {
                            let paramsStart = { ...item };
                            Reflect.set(paramsStart, 'data', start);
                            Array1.push(paramsStart);
                            stringPre = `${stringPre}${start}`
                          }
                          if (end) {
                            let paramsEnd = { ...item };
                            Reflect.set(paramsEnd, 'data', end);
                            Array2.push(paramsEnd);
                            stringSuf = `${stringSuf}${end}`;
                          }
                          // }
                        } else {
                          // console.log(item,"结尾item");
                          if (!state) {
                            Array1.push(item);
                            if (((item.dataType) !== 'tag') && !!(item.data)) {
                              stringPre = `${stringPre}${item.data}`;
                            }
                          } else {
                            Array2.push(item);
                            if (((item.dataType) !== 'tag') && !!(item.data)) {
                              stringSuf = `${stringSuf}${item.data}`;
                            }
                          }
                        }
                      } else {
                        // console.log(findId, item, ele.endOffset, TextNodes2.length, 'ele');
                        // 判断当前光标偏移是奇数/偶数
                        // console.log(findId, item, index, TextNodes2.length - 1, '-----');
                        // && index !== TextNodes2.length - 1
                        if ((findId === item.fid) && ele.endOffset !== TextNodes2.length) {
                          state = true
                        }
                        if (!state) {
                          let paramsStart = { ...item };
                          Array1.push(paramsStart);
                          if (((item.dataType) !== 'tag') && !!(item.data)) {
                            stringPre = `${stringPre}${item.data}`;
                          }
                        } else {
                          let paramsEnd = { ...item };
                          Array2.push(paramsEnd);
                          if (((item.dataType) !== 'tag') && !!(item.data)) {
                            stringSuf = `${stringSuf}${item.data}`;
                          }
                        }
                      }
                    });
                    let tempPre = Object();
                    //返回atoms字段的数据--拼接对象
                    Reflect.set(tempPre, 'atoms', Array1);
                    Reflect.set(tempPre, 'sort', (currentInfo.sort));
                    Reflect.set(tempPre, 'text', stringPre);
                    Reflect.set(tempPre, 'type', (currentInfo.type));
                    Reflect.set(paramsPre, 'sourceSent', stringPre);
                    Reflect.set(paramsPre, 'tagSourceSent', (tempPre));
                    let tempSuf = Object();
                    Reflect.set(tempSuf, 'atoms', Array2);
                    Reflect.set(tempSuf, 'sort', (currentInfo.sort));
                    Reflect.set(tempSuf, 'text', stringSuf);
                    Reflect.set(tempSuf, 'type', (currentInfo.type));
                    Reflect.set(paramsSuf, 'sourceSent', stringSuf);
                    Reflect.set(paramsSuf, 'tagSourceSent', (tempSuf));

                    //合成前后句
                    params.push(paramsPre);
                    params.push(paramsSuf);
                    if (stringPre && stringSuf) {
                      params.push('middle');
                    } else if (stringPre && !stringSuf) {
                      params.push('tail');
                    } else if (!stringPre && stringSuf) {
                      params.push('header');
                    }
                    //光标所在的文本域内容为空或者光标落在最后
                    if (type === 'source') {
                      if (!!(Array1.length) && !!(Array2.length)) {
                        this.$store.dispatch('editor/recordCursorPosition', params);
                        this.$store.dispatch('editor/setUpdataFragmentType', 4);
                      }
                    } else if (type === 'target') {
                      this.$store.dispatch('editor/recordCursorPositionTarget', params);
                    }
                  });
                } else {
                  if (type === 'target') {
                    let childrenNodeAll = (e.currentTarget.childNodes);
                    let TextNodes2 = domArray2(childrenNodeAll, Array());
                    TextNodes2.forEach((item) => {
                      if (item.data) {
                        stringPre = `${stringPre}${item.data}`;
                      }
                    });
                    let tempPre = Object();
                    //返回atoms字段的数据--拼接对象
                    Reflect.set(tempPre, 'atoms', TextNodes2);
                    Reflect.set(tempPre, 'sort', (currentInfo.sort));
                    Reflect.set(tempPre, 'text', null);
                    Reflect.set(tempPre, 'type', (currentInfo.type));
                    Reflect.set(paramsPre, 'sourceSent', null);
                    Reflect.set(paramsPre, 'tagSourceSent', (tempPre));
                    let tempSuf = Object();
                    Reflect.set(tempSuf, 'atoms', Array2);
                    Reflect.set(tempSuf, 'sort', (currentInfo.sort));
                    Reflect.set(tempSuf, 'text', stringPre);
                    Reflect.set(tempSuf, 'type', (currentInfo.type));
                    Reflect.set(paramsSuf, 'sourceSent', stringPre);
                    Reflect.set(paramsSuf, 'tagSourceSent', (tempPre));
                    params.push(paramsPre);
                    params.push(paramsSuf);
                    params.push('tail');

                    this.$store.dispatch('editor/recordCursorPositionTarget', params);
                    //备注
                  }
                }
              }
            }
          }
        }
      }
    },

    //术语划词
    setTerm(e) {
      if (this.mousedownType) {
        // if ((this.getEditorRightShownInfo.column) === 'second') return
        let oerationSignParams = {}
        if (e.clientX !== this.clientX || e.clientY !== this.clientY) {
          Reflect.set(oerationSignParams, 'column', this.getEditorRightShownInfo.column);
          if (this.mousedownType === 'source') {
            this.targetKeyword = ''
            this.sourceKeyword = window.getSelection().toString()
            Reflect.set(oerationSignParams, 'sourceKeyword', this.sourceKeyword);
            Reflect.set(oerationSignParams, 'targetKeyword', this.targetKeyword);
            this.$store.dispatch('editor/setOerationSignInfo', oerationSignParams);
          } else if (this.mousedownType === "target") {
            this.targetKeyword = window.getSelection().toString()
            Reflect.set(oerationSignParams, 'sourceKeyword', this.sourceKeyword);
            Reflect.set(oerationSignParams, 'targetKeyword', this.targetKeyword);
            this.$store.dispatch('editor/setOerationSignInfo', oerationSignParams);
          }
        }
        this.mousedownType = ''
      }
    },

    //原文键盘事件
    handleMouseupSource(e, item, type) {
      const ele = window.getSelection();
      let info = ele.anchorNode.parentNode;
      info && this.handleMouseup(e, item, type, info);
    },

    //键盘事件
    handleKeyupSource(e, item, index, type) {
      // (Ctrl+箭头上)
      if (e.ctrlKey && ((e.keyCode) === 38)) {
        this.updataType = 'enterPre';
        eventUtil.preventDefault(e);
        let contentList = (this.getList);
        if (!(contentList.length) && !(e.target.id)) {
          return false
        }
        let EleId = e.target.id;
        let EleIdArr = EleId.split('-');
        if (EleIdArr.length) {
          let id = EleIdArr[1];
          contentList.every((item, index) => {
            if (parseInt(item.id) === parseInt(id)) {
              if (index === 0) {
                //键盘事件事件
                this.$message.warning('已经是第一条信息')
                this.updataType = 'enter';
                this.$nextTick(() => {
                  document.getElementById(`${type}-${item.id}`).blur();
                })
                return false
              } else {
                this.updataType = 'enterPre';
                this.$nextTick(() => {
                  document.getElementById(`${type}-${item.id}`).blur();
                })
                return false
              }
            } else {
              return true
            }
          })
        }
      } else {
        switch (e.keyCode) {
          case 37:
            this.handleMouseupSource(e, item, type);
            console.log('左键');
            break;
          case 38:
            this.handleMouseupSource(e, item, type);
            console.log('上键');
            break;
          case 39:
            this.handleMouseupSource(e, item, type);
            console.log('右键');
            break;
          case 40:
            this.handleMouseupSource(e, item, type);
            console.log('下键');
            break;
          case 8:
          case 46:
            this.handleMouseupSource(e, item, type);
            console.log('删除键');
            break;
          default:
            this.handleMouseupSource(e, item, type);
            break;
        }
      }
    },

    //获取tag的属性信息
    getInfo(row, type) {
      let infos;
      let SentInfo;
      if ((type === 'source') && !!(row.tagSourceSent)) {
        SentInfo = JSON.parse((row.tagSourceSent));
      }
      if ((type === 'target') && !!(row.tagTargetSent)) {
        SentInfo = JSON.parse((row.tagTargetSent));
      } else {
        SentInfo = JSON.parse((row.tagSourceSent));
      }
      if ((SentInfo)) {
        let SentInfos = (SentInfo.fragments[0].atoms) || [];
        let newSentInfos = SentInfos.filter(item => item.dataType === 'text')
        if (newSentInfos.length) {
          infos = `${(newSentInfos[0].atomKey) || (row.templateKey)}*${(newSentInfos[0].dataType) || 'text'}*${(newSentInfos[0].id) || (row.id)}*${(newSentInfos[0].sort) || `${parseInt((row.id).toString().substr(0, 5))}`}*${(newSentInfos[0].style) || 'style'}*${(newSentInfos[0].tagType) || 'text'}`;
        } else {
          infos = `${(row.templateKey)}*${'text'}*${(row.id)}*${`${parseInt((row.id).toString().substr(0, 5))}`}*${'style'}*${'text'}`;
        }
        return infos
      }
    },

    //更新句子状态
    handleUpdataState(item) {
      let params = {};
      let dom = document.getElementById(`target-${item.id}`);
      let domText = dom ? (dom.innerText).replace(/\s+/g, "") : null;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        let target = JSON.parse(item.tagTargetSent)
        if (!!target.fragments[0].atoms[0].data || !!domText) {
          const { taskType, projectId, taskId, fileId } = this.getUrlInfo
          if (parseInt(taskType)) {
            Reflect.set(params, 'sentId', item.id);
            Reflect.set(params, 'projectId', projectId);
            Reflect.set(params, 'taskType', taskType);
            Reflect.set(params, 'taskId', taskId);
            Reflect.set(params, 'fileId', fileId);
            Reflect.set(params, 'isUpdateTargetSent', this.isupdateStatus);
            this.$store.dispatch('editor/fragmentQAInfo', params);
            this.$store.dispatch('editor/updataSentStatus', params);
            // 任务进度
            let taskProgressParams = {};
            Reflect.set(taskProgressParams, 'id', fileId);
            Reflect.set(taskProgressParams, 'fileId', fileId);
            Reflect.set(taskProgressParams, 'taskId', taskId);
            Reflect.set(taskProgressParams, 'taskType', taskType);
            if (this.getUrlInfo.transModel) {
              // isClassVersion 是否是班级管理版本 作业进度接口参数
              Reflect.set(taskProgressParams, 'isClassVersion', 1);
            }
            this.$store.dispatch('editor/getTaskProgress', taskProgressParams);
            this.isupdateStatus = 0;
            //修改状态完 清除跳转高亮
            const dom = document.querySelectorAll('.translated-unsure')[0].parentNode.parentNode.parentNode;
            const styleDom = dom.childNodes[2];
            styleDom.style.border = "none";
            styleDom.style.borderRight = '1px #E5E5E5 solid';
          } else {
            this.$message.warning('译文为空,或者句子已经确认')
            this.isupdateStatus = 0;
          }
        } else {
          this.$message.warning('译文为空,不可确认句子');
          this.isupdateStatus = 0;
        }
      }, 500)
    },

    /**
     * @desc 判断当前句段是否是锁定
     * @return {boolean}
     */
    lockState(item) {
      const { type } = this.getUrlInfo
      //可读可写的状态 - 1/0
      // ifOnlyPreview:0  是否只能预览：0.不是 1.是
      let ifOnlyPreview = !(parseInt(this.getTaskContentList.ifOnlyPreview) === 1);
      if (item) {
        //文件内重复- sameFileSentNo > 0    锁定/不锁定
        let fileSome = (parseInt(item.sameFileSentNo) === 0);
        //项目内重复- sameProjectSentNo > 0 锁定/不锁定
        let projectSome = (parseInt(item.sameProjectSentNo) === 0);
        if (type === 'project') {
          //是否被拆分 0/1 - (未分配/分配) - (能编辑/编辑)
          let isSplit = !(parseInt(this.getFileInfo.isSplit));
          return isSplit && ifOnlyPreview && projectSome && fileSome;
        } else if (type === 'task' || type === 'school') {
          let isFinish = parseInt(this.getFileTaskInfo.finish) !== 1;
          if (type === "school") {
            let islock = this.getUserInfo.id === this.getProjectInfo.pmUserId;
            if (islock) {
              return islock && ifOnlyPreview && projectSome && fileSome;
            } else {
              return isFinish && ifOnlyPreview && projectSome && fileSome;
            }
          }
          return isFinish && ifOnlyPreview && projectSome && fileSome;
        }
      }
    },

    /**
     * @desc 机翻图标
     * @return {string}
     */

    /**
     * @desc 获取当前句子的状态
     * @return {object} params 返回html标签 title属性内容及 className对应类名
     */
    //检查浏览器
    checkBrowser() {
      let userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("firefox") !== -1 || userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
        this.contentEditableValue = "true";
      }
    },
  }
}
</script>

<style lang="less" scoped="true">
@import "./assets/style.less";
</style>
<style scoped lang="less">
.df {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;

  .correct-item {
    position: absolute;
  }
}
</style>
